/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AnnouncementContainer_settings = {
    readonly announcement: {
        readonly id: string;
        readonly content: string;
    } | null;
    readonly " $refType": "AnnouncementContainer_settings";
};
export type AnnouncementContainer_settings$data = AnnouncementContainer_settings;
export type AnnouncementContainer_settings$key = {
    readonly " $data"?: AnnouncementContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"AnnouncementContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnnouncementContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Announcement",
            "kind": "LinkedField",
            "name": "announcement",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '756b24c89a28e99e21dd46e54694ec0b';
export default node;
